// extracted by mini-css-extract-plugin
export default {"container":"add-correction-transaction-modal_container__zUa0m","element":"add-correction-transaction-modal_element__soL4L"};